import { masters, formatDate } from "@nexseed/shared";
import { CalendarRange, Scale } from "lucide-react";
import { defineMaster, type MasterRow } from "../spec";

const status = { id: "isActive", header: "Status", kind: "status" } as const;
const activeSwitch = {
  name: "isActive",
  label: "Active",
  type: "switch",
} as const;

export const yearCodes = defineMaster({
  key: "year-codes",
  title: "Year codes",
  singular: "Year code",
  legacyName: "Year Code Master",
  description:
    "Season letter used in lot and document numbers (DY09683 → Y), with the date window it covers.",
  icon: CalendarRange,
  schema: masters.yearCode.create,
  searchPlaceholder: "Search code",
  defaultSort: "fromDate",
  hardDelete: true,
  optionLabel: (r: MasterRow) =>
    `${String(r.code)} (${formatDate(String(r.fromDate))} → ${formatDate(String(r.toDate))})`,
  columns: [
    { id: "code", header: "Code", kind: "mono", sortable: true },
    { id: "fromDate", header: "From", kind: "date", sortable: true },
    { id: "toDate", header: "To", kind: "date" },
  ],
  fields: [
    {
      name: "code",
      label: "Code",
      type: "text",
      transform: "upper",
      required: true,
      colSpan: 2,
    },
    { name: "fromDate", label: "From", type: "date", required: true },
    { name: "toDate", label: "To", type: "date", required: true },
  ],
});

export const lossTypes = defineMaster({
  key: "loss-types",
  title: "Loss types",
  singular: "Loss type",
  legacyName: "Loss Master",
  description:
    "Classifications for the per-line difference (Arrival Loss / Gain are auto-calculated).",
  icon: Scale,
  schema: masters.lossType.create,
  searchPlaceholder: "Search code or name",
  defaultSort: "name",
  optionLabel: (r: MasterRow) => `${String(r.code)} · ${String(r.name)}`,
  columns: [
    { id: "code", header: "Code", kind: "mono", sortable: true },
    { id: "name", header: "Name", sortable: true },
    { id: "isLoss", header: "Loss?", kind: "bool" },
    { id: "isAutoCalculated", header: "Auto", kind: "bool" },
    status,
  ],
  fields: [
    {
      name: "code",
      label: "Code",
      type: "text",
      transform: "upper",
      required: true,
      description: "1–3 letters",
    },
    { name: "name", label: "Name", type: "text", required: true },
    {
      name: "isLoss",
      label: "Counts as loss (unticked = gain)",
      type: "checkbox",
      colSpan: 2,
    },
    {
      name: "isAutoCalculated",
      label: "Auto-calculated from the difference",
      type: "checkbox",
      colSpan: 2,
    },
    activeSwitch,
  ],
});
